import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { Router } from '../router/router';

import { AppComponent } from './app.component';
import { LoginComponent } from '../mainpage/login/login.component';
import { CustomerComponent } from '../mainpage/customer/customer.component';
import { FirstpageComponent } from '../mainpage/frontpage/firstpage.component';

import { LocationStrategy, HashLocationStrategy} from "@angular/common";
import { HttpAddress } from "../service/httpaddress";
import { CookieService} from "ng2-cookies";
import { CoverComponent } from '../mainpage/cover/cover.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    CustomerComponent,
    FirstpageComponent,
    CoverComponent,
  ],
  imports: [
    RouterModule.forRoot(Router,
      { enableTracing: true },
      // <-- debugging purposes only
    ),
    BrowserModule,
    FormsModule,
    HttpModule,
  ],
  providers: [
    HttpAddress,
    CookieService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts